import Profile from "@/pages/Profile/index.vue";
import auth from "../middleware/authMiddleware.js";

export default {
  path: "/profile",
  name: "Profile",
  component: Profile,
  meta: {
    middleware: [auth]
  }
};
